import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';

import { DataProcessingGroupByProps } from '../../../types/reduxTypes/dataProcessingGroupBy';

const createReducer = <T extends SliceCaseReducers<DataProcessingGroupByProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setDataProcessingGroupByData(state, action) {
    state.dataProcessingGroupByData = action.payload;
  },
  setDataProcessingGroupByStatus(state, action) {
    state.dataProcessingGroupByStatus = action.payload;
  }
});

export default reducers;
